__turbopack_context__.v({
  "caret": "jLFkyq_caret",
  "collapsible": "jLFkyq_collapsible",
  "lg": "jLFkyq_lg",
  "md": "jLFkyq_md",
  "sm": "jLFkyq_sm",
  "toggle": "jLFkyq_toggle",
});
